const accessStudentExam = {
    STUDENT_EXAM_LIST: { name: 'Student Exam', path: '/student-exam-list' },
    STUDENT_EXAM_INSTRUCTIONS: { name: 'Student Exam Instructions', path: '/student-exam-instructions' },
    STUDENT_EXAM_START: { name: 'Start Student Exam', path: '/student-exam-start' },
    STUDENT_EXAM_DETAILS: { name: 'Student Exam Details', path: '/student-exam-details' },
}

export default accessStudentExam;
